import { getAllStrategies, getStrategyPositionsForScw } from '$lib/apis/strategies';
import { strategyConfig } from '$lib/config/strategies';
import { smartContractWalletAddress } from '$lib/home/scwallet/store';
import {
	firstTimeFetchingStrategyPositions,
	strategyDetails,
	strategyPositions
} from '$lib/strategies/store';
import type { StrategyPosition, StrategyType } from '$lib/types/strategy';
import { get } from 'svelte/store';

export async function getAllStrategyData() {
	const data: Array<StrategyType> | undefined = await getAllStrategies();
	setStratergyData(data);
}

export async function setStratergyData(data: Array<StrategyType> | undefined) {
	if (!data) return;
	data = data.map((item) => ({ ...item, ...strategyConfig[item?.id] }));
	strategyDetails.set(data);
}

export async function getScwStrategyPositionsData() {
	let data: Array<StrategyPosition> | undefined = await getStrategyPositionsForScw(
		get(smartContractWalletAddress)
	);
	if (!data) return;
	data = data.map((item) => ({ ...item, ...strategyConfig[item?.strategyIdentifier] }));
	strategyPositions.set(data);
	if (get(firstTimeFetchingStrategyPositions) && get(smartContractWalletAddress)) {
		firstTimeFetchingStrategyPositions.set(false);
	}
}
